import axios from "axios";

export const SERVER_UNREACHABLE =
  "Can't reach the server. Try again in a moment.";

function mentions(details: unknown, signal: string): boolean {
  if (details === signal) return true;
  if (Array.isArray(details))
    return details.some((item) => mentions(item, signal));
  if (details && typeof details === "object")
    return Object.values(details).some((value) => value === signal);
  return false;
}

export function isSuperseded(err: unknown): boolean {
  if (!axios.isAxiosError(err)) return false;
  const body = err.response?.data as { error?: unknown } | undefined;
  const error = body && typeof body === "object" ? body.error : null;
  const one = (Array.isArray(error) ? error[0] : error) as {
    code?: string;
    details?: unknown;
  } | null;
  return (
    one?.code === "ERR_UNAUTHENTICATED" &&
    mentions(one.details, "refresh_superseded")
  );
}

// 503 + ERR_DEPENDENCY_UNAVAILABLE + reason unavailable, data null.
// The refresh token was not rotated, so this is safe to retry.
export function dependencyDown(err: unknown): boolean {
  if (!axios.isAxiosError(err) || err.response?.status !== 503) return false;
  const body = err.response.data as {
    data?: unknown;
    error?: { code?: string; details?: unknown };
  } | null;
  if (!body || typeof body !== "object" || body.data != null) return false;
  const error = Array.isArray(body.error) ? body.error[0] : body.error;
  return (
    error?.code === "ERR_DEPENDENCY_UNAVAILABLE" &&
    mentions(error.details, "unavailable")
  );
}

// Only 401 and 403 end the session. 500 keeps the token and is not retried.
export function shouldDrop(err: unknown): boolean {
  if (!axios.isAxiosError(err) || isSuperseded(err) || axios.isCancel(err))
    return false;
  const status = err.response?.status;
  return status === 401 || status === 403;
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
